export enum SignupByInvitePath {
  token = "token",
}

export interface PathParams {
  [SignupByInvitePath.token]: string;
}
